import React, { useEffect, useState } from 'react';
import hero from "../Assets/KK BANNER.png";
import board from '../Assets/Artboard 1.png';
import bird from '../Assets/bird.svg';
import childrens from '../Assets/people-button.svg';
import { Parallax, ParallaxProvider } from 'react-scroll-parallax';

const Home = () => {
  const [scale, setScale] = useState(1); // State to manage scaling

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newScale = Math.max(0.5, 1 - scrollY / 1000); // Adjust scaling
      setScale(newScale);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <ParallaxProvider>
      <div className="-mt-16">
        {/* Hero Section */}
        <div className="relative sm:h-screen h-96 md:h-screen">
          {/* Background Image */}
          <img
            src={hero}
            alt="Hero"
            className="w-full h-full object-cover"
          />
          {/* Overlay Content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
            {/* Board Image */}
            <div className="relative">
              <img
                src={board}
                alt="Board"
                className="relative h-[490px] w-[590px] sm:h-[1100px] sm:w-[1100px] md:h-[1400px] md:w-[1400px]  top-20 sm:top-24 md:top-60 lg:top-52"
                style={{ zIndex: 10 }}
              />
              {/* Text Content */}
              <div className="absolute sm:top[30%] top-[85%] sm:top-[85%]  md:top-[62%] lg:top-[70%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center z-20">
                <Parallax translateY={[-100, 100]} className="mb-7">
                  <img src={bird} alt="Bird" className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24" />
                </Parallax>
                <div className="text-[#0a3039] text-[#16bab1]enter sm:-mt-12 md:-mt-0   -mt-0  navbar-link">
                  <h1 className="text-sm sm:text-xl md:text-[#16bab1]xl font-bold ">Discovering the Joy of </h1>
                  <h2 className="text-[#16bab1]xl sm:text-5xl md:text-7xl font-bold ">Learning</h2>
                  <h3 className="text-sm sm:text-3xl md:text-[#16bab1]xl font-bold ">Through Play</h3>
                </div>

                <div className="relative">
                  <img
                    src={childrens}
                    alt="Children"
                    className={` -mt-36 sm:-mt-20 md:-mt-28`}
                    style={{
                      width: `${scale * 350}px`, // Adjust  size for different   devices
                      height: `${scale * 430}px`,
                    }}
                    
                  />
                </div>
<button
  className="absolute bg-[#16bab1] text-white md:mt-28 -mt-10 sm:mt-12 rounded-lg transition-all"
  style={{
    top: `calc(${150 + scale * 40}px)`, // Adjust top position dynamically
    width: `${scale * 120}px`, // Scale width
    height: `${scale * 40}px`, // Scale height
    fontSize: `${scale * 14}px`, // Scale font size
  }}
>

  Get Started
</button>
              </div>
            </div>
          </div>
          <div className="wave rotate-180 -mt-40"></div>
          
        </div>
      </div>
    </ParallaxProvider>
  );
};

export default Home;
 